// @flow

import * as React from 'react'
import { Popup, Button } from 'semantic-ui-react'

import type { ChartType } from '../store/reports'

type OwnProps = {
  chartType: ChartType,
  onChangeType: ChartType => void,
}

class ChartTypeToolbar extends React.Component<OwnProps> {
  render() {
    let baseProps = {
      inverted: true,
      position: 'bottom left',
    }
    return (
      <Button.Group size="small">
        <Popup
          trigger={
            <Button
              icon="area chart"
              content="Area Chart"
              primary
              style={{ minWidth: '16ex', backgroundColor: this.props.chartType === 'AREA' ? '' : '#79B6E3' }}
              active={this.props.chartType === 'AREA'}
              onClick={() => this.props.onChangeType('AREA')}
            />
          }
          content="Valori aggregati per canale"
          {...baseProps}
        />
        <Popup
          trigger={
            <Button
              icon="line chart"
              content="Line Chart"
              primary
              style={{ minWidth: '16ex', backgroundColor: this.props.chartType === 'LINE' ? '' : '#79B6E3' }}
              active={this.props.chartType === 'LINE'}
              onClick={() => this.props.onChangeType('LINE')}
            />
          }
          content="Valori assoluti / canale"
          {...baseProps}
        />
      </Button.Group>
    )
  }
}

export default ChartTypeToolbar



// WEBPACK FOOTER //
// ./src/reports/chart-type-toolbar.js